import { get, patch, post, put } from './request';
import { AxiosError } from 'axios';
import { ActivePolicy } from './bond-insurance-policy';

export type claimFiltersType = {
  page: number;
  estateId?: string | null;
  insurerId?: string | string[] | null;
  claimEstateStatus?: string | string[] | null;
  claimPropertyStatus?: string | string[] | null;
  productType?: string | string[] | null;
  start?: Date | null;
  end?: Date | null;
  responsibleId?: string | string[] | null;
  estateResponsibleId?: string | null;
  address?: string | null;
  propertyCode?: string | null;
  name?: string | null;
  onlyUnread: boolean | null;
  userId?: string | null;
  isReport?: boolean | null;
};
interface IGetClaims {
  id?: string;
  filters?: claimFiltersType;
  isReport?: boolean;
  sortColumn?: string | null;
  sortDirection?: string | null;
}

export const getClaims = async ({
  id,
  filters,
  sortColumn,
  sortDirection
}: IGetClaims) => {
  let url = id ? `/claims/${id}` : '/claims';

  let query = '';

  if (filters) {
    Object.entries(filters).forEach((map: [string, any]) => {
      if (map[1]) {
        query += `${map[0]}=${map[1]}&`;
      }
    });
  }

  if (sortColumn) {
    query += `sortColumn=${encodeURIComponent(sortColumn)}&`;
  }
  if (sortDirection) {
    query += `sortDirection=${encodeURIComponent(sortDirection)}&`;
  }

  if (query.endsWith('&')) {
    query = query.slice(0, -1);
  }

  url = query ? `${url}?${query}` : url;

  const response = await get(url);

  return response;
};

export async function getAllDashboards() {
  const response = await get('/dashboard');

  return response;
}

export const getClaimsReport = async ({
  filters
}: IGetClaims): Promise<number | undefined> => {
  let query = '';

  if (filters) {
    filters.isReport = true;

    Object.entries(filters).forEach((map: [string, any]) => {
      if (map[1]) {
        query += `${map[0]}=${map[1]}&`;
      }
    });
  }

  try {
    const response = await get(`/claims/report-excel?${query}`);
    return response.status;
  } catch (error) {
    const { response } = error as AxiosError;
    return response?.status;
  }
};

export async function getClaimsByClaimResponsible(
  claimResponsibleId: string,
  estates: string[]
) {
  const estatesJoined = estates.join(',');
  const response = await get(
    `/claims/by-responsible-and-estates/${claimResponsibleId}/${estatesJoined}`
  );
  return response;
}

export async function transferClaimsResponsibleById(
  oldClaimResponsibleId: string,
  newClaimResponsibleId: string,
  estates: string[],
  shouldTransferClaims: boolean
) {
  const estatesJoined = estates.join(',');
  return patch(`/claims/transfer-estates-claim-responsible`, {
    oldUser: oldClaimResponsibleId,
    newUser: newClaimResponsibleId,
    estatesIds: estatesJoined,
    shouldTransferClaims
  });
}

export async function updateClaimEstateResponsible(
  claimId: string,
  estateResponsibleId: string | null
) {
  return patch(`/claims/${claimId}/estate-responsible`, {
    estateResponsibleId
  });
}

export const getClaimByPolicyNumber = async (policyNumber: string) => {
  return await get(`/claims/check-policy-number/${policyNumber}`);
};



export const getActivePoliciesByTenantDocument = async (
  document: string
): Promise<ActivePolicy[]> => {
  // Remove máscara do documento
  const cleanDocument = document.replace(/\./g, '').replace(/\-/g, '').replace(/\//g, '');
  return await get(`/claims/check-policies-by-document/${cleanDocument}`);
};

export const getClaimByTenantDocument = async (document: string) => {
  // Remove máscara do documento
  const cleanDocument = document.replace(/\./g, '').replace(/\-/g, '').replace(/\//g, '');
  return await get(`/claims/check-claim-by-tenant-document/${cleanDocument}`);
};

export const getClaimByAddress = async (body: any) => {
  return await post(`/claims/check-address`, body);
};

export const getClaimPortoLogs = async (id: string) => {
  const response = await get(`/claims/${id}/porto-logs`);
  if (Array.isArray(response)) {
    return response;
  }
  if (Array.isArray(response?.data)) {
    return response.data;
  }
  return [];
};

export const updateClaimPortoLogsViewed = async (id: string, viewed: boolean) => {
  return await put(`/claims/${id}/porto-logs/viewed`, { viewed });
};

export type ClaimGaranttiLogsResponse = {
  data: Array<{
    id: string;
    externalId?: string;
    eventDate: string;
    eventTime: string;
    title: string;
    description?: string | null;
    viewed: boolean;
  }>;
  linked: boolean;
  garanttiSinisterId?: string | null;
  certificateNumber?: string | null;
};

export const getClaimGaranttiLogs = async (
  id: string
): Promise<ClaimGaranttiLogsResponse> => {
  const response = await get(`/claims/${id}/garantti-logs`);
  if (Array.isArray(response)) {
    return {
      data: response,
      linked: response.length > 0,
      garanttiSinisterId: null,
      certificateNumber: null
    };
  }
  return {
    data: Array.isArray(response?.data) ? response.data : [],
    linked: Boolean(response?.linked),
    garanttiSinisterId: response?.garanttiSinisterId || null,
    certificateNumber: response?.certificateNumber || null
  };
};

export const updateClaimGaranttiLogsViewed = async (id: string, viewed: boolean) => {
  return await put(`/claims/${id}/garantti-logs/viewed`, { viewed });
};
